function ArrowSquareUp() {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
            >
                  <path
                        stroke="#005BB2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M15 2H9C4 2 2 4 2 9v6c0 5 2 7 7 7h6c5 0 7-2 7-7V9c0-5-2-7-7-7z"
                  ></path>
                  <path
                        stroke="#005BB2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M15.53 10.54L12 14.06l-3.53-3.52"
                  ></path>
            </svg>
      );
}

export default ArrowSquareUp;
